const recentViewdProduct = document.querySelector(".recently_viewed_proudct");
const recentViewedProductHandle = recentViewdProduct.dataset.productHandle;
var LOCAL_STORAGE_RECENTVIEWPRODUCT_KEY = "shopify-recent-view";
var LOCAL_STORAGE_DELIMITER = ",";
var BUTTON_ACTIVE_CLASS = "active";

/* Fix 30.08.2026 — Obergrenzen.
   Vorher wuchs die Liste im localStorage unbegrenzt und es wurde pro
   gespeichertem Produkt ein eigener fetch() abgesetzt. Wer 40 Produkte
   angesehen hatte, loeste auf jeder Produktseite 40 Requests aus und bekam
   40 Karten ins DOM. */
var MAX_RECENT_VIEWED_STORED = 12;
var MAX_RECENT_VIEWED_SHOWN = 8;

var selectors = {
  grid: "[grid-recentViewProduct]",
};

document.addEventListener("DOMContentLoaded", function () {
  var productHandle = recentViewedProductHandle || false;
  if (!productHandle)
    return console.error(
      "[recentViewPorduct] Missing `data-product-handle` attribute. Failed to update the recentViewPorduct."
    );
  updaterecentViewPorduct(productHandle);

  var Recentgrid = document.querySelector(selectors.grid) || false;
  if (Recentgrid) {
    recentViewsetupGrid(Recentgrid);
  }
});

var recentViewsetupGrid = function (Recentgrid) {
  var recentViewPorduct = getrecentViewPorduct()
    .filter(function (handle) {
      return handle && handle !== recentViewedProductHandle;
    })
    .reverse()
    .slice(0, MAX_RECENT_VIEWED_SHOWN);

  if (recentViewPorduct.length > 0) {
    recentViewdProduct.classList.remove("no-js-inline");
  }

  var requestsRecentViewed = recentViewPorduct.map(function (handle) {
    var productTileTemplateUrl = "/products/" + handle + "?view=card";
    return fetch(productTileTemplateUrl)
      .then(function (res) {
        return res.status === 200 ? res.text() : "";
      })
      .catch(function () {
        return "";
      });
  });

  Promise.all(requestsRecentViewed).then(function (responses) {
    var recentViewPorductProductCards = responses.join("");
    Recentgrid.innerHTML = recentViewPorductProductCards;
  });
};

var getrecentViewPorduct = function () {
  var recentViewPorduct =
    localStorage.getItem(LOCAL_STORAGE_RECENTVIEWPRODUCT_KEY) || false;
  if (recentViewPorduct)
    return recentViewPorduct.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

var setrecentViewPorduct = function (array) {
  var recentViewPorduct = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length)
    localStorage.setItem(
      LOCAL_STORAGE_RECENTVIEWPRODUCT_KEY,
      recentViewPorduct
    );
  return recentViewPorduct;
};

var updaterecentViewPorduct = function (handle) {
  /* Doppelte Eintraege entfernen, aktuelles Produkt ans Ende, Liste kappen.
     Ersetzt das fruehere splice/push, das ein Array statt eines Handles
     zurueckgeschrieben hat. */
  var recentViewPorduct = getrecentViewPorduct().filter(function (item) {
    return item && item !== handle;
  });
  recentViewPorduct.push(handle);
  if (recentViewPorduct.length > MAX_RECENT_VIEWED_STORED) {
    recentViewPorduct = recentViewPorduct.slice(-MAX_RECENT_VIEWED_STORED);
  }
  return setrecentViewPorduct(recentViewPorduct);
};

var recentViewPorductContains = function (handle) {
  var recentViewPorduct = getrecentViewPorduct();
  return recentViewPorduct.indexOf(handle) !== -1;
};

var resetrecentViewPorduct = function () {
  return setrecentViewPorduct([]);
};
